import { User } from 'domain/User';
import { ActionFactory } from '../types';
import {
  ActionType, SetUserListLoadingAction, AddUserAction, UpdateUserAction, RemoveUserAction,
  RefreshUserListAction,
} from './types';

export const setIsUserListLoading: ActionFactory<boolean, SetUserListLoadingAction> = (isLoading) => ({
  type: ActionType.SET_USER_LIST_LOADING,
  isLoading,
});

export const addUser: ActionFactory<User, AddUserAction> = (newUser) => ({
  type: ActionType.ADD_USER,
  user: newUser,
});

export const removeUser: ActionFactory<User, RemoveUserAction> = (deletedUser) => ({
  type: ActionType.REMOVE_USER,
  user: deletedUser,
});

export const updateUser: ActionFactory<User, UpdateUserAction> = (updatedUser) => ({
  type: ActionType.UPDATE_USER,
  user: updatedUser,
});

export const refreshUserList: ActionFactory<User[], RefreshUserListAction> = (newUserList) => ({
  type: ActionType.REFRESH_USER_LIST,
  userList: newUserList,
});
